export const weeklySparklineAreaData = [
    { x: 1, y: 1533 },
    { x: 2, y: 1200 },
    { x: 3, y: 1788 },
    { x: 4, y: 1425 },
    { x: 5, y: 2501 },

];